export const ADD_SHARED_SURVEY = "ADD_SHARED_SURVEY";
export const SET_SURVEY_REPLIED = "SET_SURVEY_REPLIED";